import { render, staticRenderFns } from "./IconSuitcase.vue?vue&type=template&id=3261438b"
import script from "./IconSuitcase.vue?vue&type=script&lang=js"
export * from "./IconSuitcase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports